<template>
  <div>
    <div class="title">{{ data.title }}</div>
    <div class="text" v-html="data.content"></div>
  </div>
</template>
<script>
export default {
  name: 'ContactMePreview',
  props: {
    data: Object
  }
}
</script>
<style scoped>
.title {
  font-size: 14px;
  padding: 15px 0 5px 15px;
  background-color: #eff2f7;
  font-weight: normal;
  color: #666;
}
.text {
  font-size: 14px;
  padding: 12px 15px;
  white-space: pre-line;
  word-break: break-all;
  word-wrap: break-word;
  overflow: hidden;
  background-color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/contactMe/ContactMePreview.vue